import { render, staticRenderFns } from "./Recruit.vue?vue&type=template&id=97116dee&scoped=true&"
import script from "./Recruit.vue?vue&type=script&lang=ts&"
export * from "./Recruit.vue?vue&type=script&lang=ts&"
import style0 from "./Recruit.vue?vue&type=style&index=0&id=97116dee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97116dee",
  null
  
)

export default component.exports